import axios from 'axios';

export function getScreenHostSignupStoreTypes() {
    return axios.get(`${process.env.REACT_APP_API_URL}/screenHost/signup/store-types`);
}

export function screenHostSignupSendCode(email) {
    return axios.post(`${process.env.REACT_APP_API_URL}/screenHost/signup/send-code`, { email });
}

export function screenHostSignupVerifyCode(email, code) {
    return axios.post(`${process.env.REACT_APP_API_URL}/screenHost/signup/verify-code`, { email, code });
}

export function screenHostSignup(payload) {
    return axios.post(`${process.env.REACT_APP_API_URL}/screenHost/signup`, payload);
}
